import React from 'react';
import './Spinner.css';

const Spinner = ({ size = 'medium', text = 'Loading...' }) => {
  return (
    <div className={`spinner-container ${size}`}>
      <div className="spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      {text && <p className="spinner-text">{text}</p>}
    </div>
  );
};

export default Spinner;
